import { useEffect, useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { isBuilderPreview } from "./useSiteLayout";

const BASE = process.env.REACT_APP_BACKEND_URL;

export const FALLBACK_GLOBALS = {
    announcement: { enabled: false },
    header: {},
    footer: {
        visible: true, tagline: "Live Better · Live Stronger",
        about: "Science-backed nutraceuticals crafted with potent herbal actives. Effervescent. Fast-absorbing. Made for men who refuse to settle.",
        newsletter_enabled: true,
        columns: [
            { id: "f_shop", title: "Shop", links: [{ id: "fl_all", label: "All Products", href: "/shop" }, { id: "fl_redrive", label: "ReDrive Max", href: "/product/redrive-max" }] },
            { id: "f_brand", title: "Brand", links: [{ id: "fl_science", label: "Science", href: "/science" }, { id: "fl_blog", label: "Blog", href: "/blog" }] },
        ],
        socials: [{ id: "s_ig", platform: "instagram", label: "@rehealthme", href: "https://instagram.com" }],
        contact_email: "support@rehealthme.com", wordmark: "Rehealthme",
        copyright: "© {year} Rehealthme. All rights reserved.", note: "Powered by Nature. Backed by Science.",
    },
};

// Header / footer / announcement bar. Inside the builder iframe the draft arrives over postMessage.
export const useGlobals = () => {
    const preview = isBuilderPreview();
    const [live, setLive] = useState(null);

    useEffect(() => {
        if (!preview) return;
        const onMessage = (e) => {
            if (e.data?.type === "rhm-globals") setLive(e.data.globals || null);
        };
        window.addEventListener("message", onMessage);
        return () => window.removeEventListener("message", onMessage);
    }, [preview]);

    const { data } = useQuery({
        queryKey: ["site-globals"],
        queryFn: async () => (await fetch(`${BASE}/api/site/globals`)).json(),
        staleTime: 30000,
        enabled: !preview,
    });

    const g = (preview ? live : data) || FALLBACK_GLOBALS;
    return {
        header: g.header || {},
        footer: g.footer || {},
        announcement: g.announcement || {},
        ready: Object.keys(g).length > 0,
    };
};

export const usePublishedPages = () => {
    const { data = [] } = useQuery({
        queryKey: ["site-pages-public"],
        queryFn: async () => (await fetch(`${BASE}/api/site/pages`)).json(),
        staleTime: 60000,
    });
    return data;
};
